import {safeHasOwnProperty} from "./Object"
import IsEmpty from "./IsEmpty"

/**
 * @typedef EmbedEvent
 * @property {Object} data
 * @property {string} data.type
 * @property {*[]} data.args
 * @property {number} data.embed
 */

export default class EmbedComms {
    /**
     *
     * @type {number}
     * @private
     */
    #id = 0

    /**
     *
     * @type {Record<string, Function[]>}
     * @private
     */
    #callbacks = {}

    /**
     *
     * @type {Record<string, EmbedEvent[]>}
     * @private
     */
    #queuedEvents = {}

    /**
     *
     * @type {Record<string, Function>}
     * @private
     */
    #internalCallbacks = {}

    constructor(id = Date.now()) {
        this.#id = id
        window.addEventListener('message', this._handleEvent.bind(this))
        this.dispatch('_channel-open', this.#id)
    }

    dispatch(type, ...args) {
        window.parent.postMessage({ type, args, embed: this.#id }, {targetOrigin: '*'})
    }

    on(eventName, callback) {
        if (safeHasOwnProperty(this.#callbacks, eventName)) {
            this.#callbacks[eventName].push(callback)
        } else {
            this.#callbacks[eventName] = [callback]
        }

        if (safeHasOwnProperty(this.#queuedEvents, eventName)) {
            while (this.#queuedEvents[eventName].length > 0) {
                this._handleEvent(this.#queuedEvents[eventName].shift())
            }
        }
    }

    off(eventName, callback) {
        if (!safeHasOwnProperty(this.#callbacks, eventName)) {
            return
        }

        this.#callbacks[eventName] = this.#callbacks[eventName].filter((registered) => registered !== callback)
    }

    /**
     *
     * @param {EmbedEvent} event
     * @private
     */
    _handleEvent(event) {
        const evType = event?.data?.type
        if (IsEmpty(evType)) {
            return
        }

        if (!safeHasOwnProperty(this.#queuedEvents, evType)) {
            this.#queuedEvents[evType] = []
        }
        if (!safeHasOwnProperty(this.#callbacks, evType)) {
            this.#callbacks[evType] = []
        }

        if (safeHasOwnProperty(this.#internalCallbacks, evType)) {
            this.#internalCallbacks[evType].apply(null, event.data.args)
        } else if (this.#callbacks[evType].length > 0) {
            let i = 0,
                t = this.#callbacks[evType].length

            if (evType === 'error') {
                event.data.args = [new Error(event.data.args[0], event.data.args[1] || {})]
            }

            for (; i < t; i++) {
                this.#callbacks[evType][i].apply(null, event.data.args)
            }
        } else {
            this.#queuedEvents[evType].push(event)
        }
    }
}
